var equalHeight = function() {
    
    function init() {
        eventListeners();
        equalHeight();
    }
    
    function eventListeners() {
        $(window).on('resize', function() {
            equalHeight();
        });
    }
    
    function equalHeight() {
        var groupName = $('[data-height]');
        var groupHeights = [];
        
        groupName.css('min-height', 'auto');
        
        groupName.each(function() {
            groupHeights.push($(this).outerHeight());
        });
        
        var maxHeight = Math.max.apply(null, groupHeights);
        groupName.css('min-height', maxHeight);
    };
    
    return {
        init: init
    };
    
} ();

$(document).ready(function() {
    if($(window).outerWidth() >= 768) {
        equalHeight.init();
    }
});
